import { Link } from 'react-router-dom';
import React from 'react';
import { connect } from 'react-redux';
import s from './style.css';
import Loading from '../../Loading';
import { ButtonText } from '../Button';
const mapStateToProps = (state) => ({
    loading: state.progress.loading,
});
const connector = connect(mapStateToProps);
const AnimatedButton = (props) => {
    if (props.clickable)
        return (React.createElement("button", { type: 'button', className: s.buttonContainer, onClick: props.onClick, style: { width: '50vw' } },
            React.createElement("span", { className: `${s.getStartedButton} ${props.style}` }, props.loading ? React.createElement(Loading, null) : React.createElement(ButtonText, { icon: props.icon, text: props.text }))));
    return (React.createElement(Link, { className: s.buttonContainer, to: props.to || '' },
        React.createElement("span", { className: `${s.getStartedButton} ${props.style}` },
            React.createElement(ButtonText, { icon: props.icon, text: props.text }))));
};
export default connector(AnimatedButton);
